import _ from "lodash";
import {QboCustomerListApiResult, StripeCustomerListApiResult} from "./ApiUtility";
import {SelectOption, SelectOptionsGroup} from "./CommonUIElementTypes";
import {FpInvoice} from "../invoices/InvoiceTypes";

export interface StripeCustomerOption extends SelectOption {
    email: string;
    name: string;
    companyName: string;
}

export interface QboCustomerOption extends SelectOption {
    email: string;
    companyName: string;
}

export interface StripeCustomerOptionsData {
    stripeCustomerOptions: StripeCustomerOption[] | SelectOptionsGroup[];
    stripeCustomerOptionsFlat: StripeCustomerOption[];
}

export interface QboCustomerOptionsData {
    qboCustomerOptions: QboCustomerOption[] | SelectOptionsGroup[];
    qboCustomerOptionsFlat: QboCustomerOption[];
}

export let CustomerDataUtility = {
    getStripeCustomerOptionsData: function (stripeCustomers: StripeCustomerListApiResult[]): StripeCustomerOptionsData {
        let stripeCustomerOptions;
        let stripeCustomerOptionsFlat;
        let previousStripeCustomerPicks = []
        let otherStripeCustomers = []

        for (let s = 0; s < (stripeCustomers || []).length; s++) {
            let customer = stripeCustomers[s];
            let customerOption: StripeCustomerOption = {
                value: customer.id,
                label: `${customer.name} (${customer.email})`,
                email: customer.email as string,
                name: customer.name as string,
                companyName: customer.business_name as string
            }
            if (customer.is_previous_choice) {
                previousStripeCustomerPicks.push(customerOption)
            } else {
                otherStripeCustomers.push(customerOption)
            }
        }

        stripeCustomerOptionsFlat = previousStripeCustomerPicks.concat(otherStripeCustomers)
        if (previousStripeCustomerPicks.length > 0 && otherStripeCustomers.length > 0) {
            stripeCustomerOptions = [
                {
                    label: "Previous choices",
                    options: previousStripeCustomerPicks
                },
                {
                    label: "Other customers",
                    options: otherStripeCustomers
                }
            ]
        } else {
            stripeCustomerOptions = _.clone(stripeCustomerOptionsFlat)
        }

        return {
            stripeCustomerOptions: stripeCustomerOptions,
            stripeCustomerOptionsFlat: stripeCustomerOptionsFlat
        }
    },

    getQboCustomerOptionsData: function (qboCustomers: QboCustomerListApiResult[]): QboCustomerOptionsData {
        let qboCustomerOptions;
        let qboCustomerOptionsFlat;
        let previousQboCustomerPicks = []
        let otherQboCustomers = []

        for (let s = 0; s < (qboCustomers || []).length; s++) {
            let customer = qboCustomers[s];
            let label = customer.displayName;
            if (customer.email) {
                label += ` (${customer.email})`;
            }
            let customerOption: QboCustomerOption = {
                value: customer.id,
                label: label as string,
                email: customer.email as string,
                companyName: customer.companyName as string
            }

            if (customer.is_previous_choice) {
                previousQboCustomerPicks.push(customerOption)
            } else {
                otherQboCustomers.push(customerOption)
            }
        }

        qboCustomerOptionsFlat = previousQboCustomerPicks.concat(otherQboCustomers)
        if (previousQboCustomerPicks.length > 0 && otherQboCustomers.length > 0) {
            qboCustomerOptions = [
                {
                    label: "Previous choices",
                    options: previousQboCustomerPicks
                },
                {
                    label: "Other customers",
                    options: otherQboCustomers
                }
            ]
        } else {
            qboCustomerOptions = _.clone(qboCustomerOptionsFlat)
        }

        return {
            qboCustomerOptions: qboCustomerOptions,
            qboCustomerOptionsFlat: qboCustomerOptionsFlat
        }
    },

    proposedCustomerFromFpInvoice: function (fpInvoice: FpInvoice) {
        let companyName = fpInvoice?.invoicecompany?.companyname || '';
        let proposedName = companyName;
        if (proposedName && fpInvoice?.invoicecontact?.contactFullName) {
            proposedName += ` - ${fpInvoice?.invoicecontact?.contactFullName}`
        }
        let proposedEmail = fpInvoice?.invoicecontact?.email || ''

        return {
            name: proposedName,
            email: proposedEmail,
            companyName: companyName
        }
    }
}
